<template>
	<section class="device-verification-login-process">
		<c-multifactor-input
			ref="mfaInput"
			:is-validated="status === 'success'"
			:is-loading="status === 'validating'"
			autofocus
			input-classes="mt-3"
			label="Please enter the code sent to your email address to continue."
			@complete="onCodeEntered"
		/>

		<button class="button--no-style text-center underline w-100" @click="resendVerificationEmail">
			Didn't receive the code? Resend now.
		</button>
	</section>
</template>

<script lang="ts">
	import type { ButtonStatus } from '@cognitoforms/shared-components/src/components/interaction/StatusButton.vue';
	import CMultifactorInput from 'src/components/form-controls/MultifactorInput.vue';
	import type { PropType } from 'vue';
	import { defineComponent, ref } from 'vue';

	export default defineComponent({
		components: {
			CMultifactorInput
		},
		props: {
			rememberMe: {
				type: Boolean,
				default: false
			},
			email: {
				type: String,
				default: null
			},
			status: {
				type: String as PropType<ButtonStatus>,
				default: 'default'
			}
		},
		emits: ['device-verified', 'resend-device-verification'],
		setup(props, { emit }) {
			const mfaInput = ref<InstanceType<typeof CMultifactorInput>>(null);

			const onCodeEntered = (code: string) => {
				emit('device-verified', code);
			};

			const resendVerificationEmail = () => {
				emit('resend-device-verification');
			};

			return {
				onCodeEntered,
				mfaInput,
				resendVerificationEmail
			};
		}
	});
</script>